export const fiscalYearFrag = `
    id
    dateFrom
    dateTo
`;

export const fiscalYearMutationFrag = `
    id
`;
